import React from 'react'

import { IconProps } from '../../../common/types'

const Import: React.FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 17 16" fill="none">
      <path
        d="M3.16675 10.6668L3.16675 11.3335C3.16675 12.4381 4.06218 13.3335 5.16675 13.3335L11.8334 13.3335C12.938 13.3335 13.8334 12.4381 13.8334 11.3335L13.8334 10.6668M11.1667 8.00016L8.50008 10.6668M8.50008 10.6668L5.83341 8.00016M8.50008 10.6668L8.50008 2.66683"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Import
